<template>
  <div id="autologin">
    <div class="autologin-page">
      <div class="autologin-content">
        <div class="infinite-loading-container"><i class="fa fa-circle-o-notch fa-spin"></i></div>
        <div>Loading</div>
        <div class="detail">Please waiting for authentication.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as types from 'store/modules/autologin/mutation-types'

export default {
  name: 'auto-login',
  created () {
    this.receivedAutoLogin(this.$route.params.runno)
  },
  computed: {
    ...mapGetters({
      autoLogin: types.GET_AUTOLOGIN
    })
  },
  methods: {
    ...mapActions({
      receivedAutoLogin: types.RECEIVED_AUTOLOGIN
    })
  }
}
</script>

<style src="./style.scss" lang="scss"></style>


// WEBPACK FOOTER //
// component.vue?b763973e